module.exports = __webpack_public_path__ + "img/noun_lesson_1766585.77101fdf.svg";